import { createApp } from 'vue'
import App from './App.vue'
import i18n from "@/locale/i18n"
import * as echarts from 'echarts';

createApp(App)
    .use(i18n)
    .use(echarts)
    .mount('#app')